import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import Layout from '@/components/Layout';
import { ROUTES } from '@/lib/constants';

// ── Code Splitting: chaque page chargée uniquement quand nécessaire ──
const HomePage                  = lazy(() => import('@/pages/home/Index'));
const BlogIndexPage             = lazy(() => import('@/pages/blog/Index'));
const BlogArticlePage           = lazy(() => import('@/pages/blog/Article'));
const ContactPage               = lazy(() => import('@/pages/contact/Index'));
const NotFoundPage              = lazy(() => import('@/pages/not-found/Index'));
const CuisineMdfPage            = lazy(() => import('@/pages/services/CuisineMdf'));
const CuisineModernePage        = lazy(() => import('@/pages/services/CuisineModerne'));
const CuisineSurMesurePage      = lazy(() => import('@/pages/services/CuisineSurMesure'));
const PlacardDressingPage       = lazy(() => import('@/pages/services/PlacardDressing'));
const CuisineEquipeePage        = lazy(() => import('@/pages/services/CuisineEquipee'));
const MentionsLegalesPage       = lazy(() => import('@/pages/legal/MentionsLegales'));
const PolitiqueConfidentialitePage = lazy(() => import('@/pages/legal/Confidentialite'));
const PlanDuSitePage            = lazy(() => import('@/pages/legal/PlanDuSite'));

// Fallback minimaliste pendant le chargement
function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="w-10 h-10 border-4 border-amber-600 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            {/* Home */}
            <Route path={ROUTES.HOME} element={<HomePage />} />

            {/* Services */}
            <Route path={ROUTES.SERVICES.CUISINE_MDF} element={<CuisineMdfPage />} />
            <Route path={ROUTES.SERVICES.CUISINE_MODERNE} element={<CuisineModernePage />} />
            <Route path={ROUTES.SERVICES.CUISINE_SUR_MESURE} element={<CuisineSurMesurePage />} />
            <Route path={ROUTES.SERVICES.PLACARD_DRESSING} element={<PlacardDressingPage />} />
            <Route path={ROUTES.SERVICES.CUISINE_EQUIPEE} element={<CuisineEquipeePage />} />

            {/* Blog */}
            <Route path={ROUTES.BLOG} element={<BlogIndexPage />} />
            <Route path={`${ROUTES.BLOG}/:slug`} element={<BlogArticlePage />} />

            {/* Contact */}
            <Route path={ROUTES.CONTACT} element={<ContactPage />} />

            {/* Pages légales */}
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialitePage />} />
            <Route path={ROUTES.SITEMAP} element={<PlanDuSitePage />} />

            {/* 404 */}
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </Layout>
    </BrowserRouter>
  );
}
